import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import PublicNav from "@/components/PublicNav";
import PublicFooter from "@/components/PublicFooter";

// PATCH 28 BW7 — public, read-only Investor/Auditor Mode view for a time-limited share token.
export default function Shared() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get(`/public/shared/${token}`).then(r => setData(r.data))
      .catch(e => setErr(e?.response?.data?.detail || "This link is not available."));
  }, [token]);

  return (
    <div className="k-canvas">
      <PublicNav />
      <section style={{ margin: "0 auto", padding: "48px 24px" }}>
        {err && <p className="k-tag-warn" data-testid="shared-error" style={{ padding: 12, borderRadius: 8 }}>{err}</p>}
        {data && (
          <div className="k-container" data-testid="shared-view" style={{ padding: 28 }}>
            <div className="k-badge k-badge-sandbox" style={{ marginBottom: 8 }}>Investor / Auditor Mode · read-only</div>
            <h1 className="k-heading" style={{ fontSize: 26, margin: "6px 0" }}>{data.project_name}</h1>
            <p className="k-muted" style={{ fontSize: 13 }}>{data.domain_label} · {data.scope_statement}</p>
            <p className="k-muted" style={{ fontSize: 13 }}>{data.connector_count} connectors · evidence pack: {data.evidence_pack_status}</p>
            <div style={{ marginTop: 10 }} data-testid="shared-layers">
              {data.layers.map((l, i) => <span key={i} className="k-badge" style={{ marginRight: 4, marginBottom: 4 }}>{l.name} · {l.status}</span>)}
            </div>
            <p className="k-tag-warn" style={{ fontSize: 13, padding: 10, borderRadius: 8, marginTop: 14 }}>{data.disclaimer}</p>
            <div className="k-muted" style={{ fontSize: 12, marginTop: 6 }}>{data.tagline} · {data.note}</div>
          </div>
        )}
      </section>
      <PublicFooter />
    </div>
  );
}
